/* Copyright (c) 2025 Xperi. All Rights Reserved. */

// Navigation constants and types
export const NAVIGATION_DIRECTION = {
    UP: 'UP',
    DOWN: 'DOWN',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
} as const;

export type TNavigationDirection = (typeof NAVIGATION_DIRECTION)[keyof typeof NAVIGATION_DIRECTION];
